.hello_class {
    color: black;
    background: yellow;
}

.btn-primary {
    --btn-primary-color: #ffeb00;
    --btn-primary-bg: #606;
    --btn-primary-border: #606;
}